/**
 * SPDX-License-Identifier: MPL-2.0
 * Copyright 2023 (c) Daniel Littfinski, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2024 (c) Marc Fischer, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import { Dispatch } from '@reduxjs/toolkit';
import MsgListActions, { BootstrapColor_t } from 'MsgList/MsgListActions';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Company, OpcUaClient } from 'Api/generated';
import Api from 'Api/Api';

interface INewOpcUaClientProps {
  companyId: Company['Id'];
  clients: OpcUaClient[];
  onChange: () => void;
}
interface INewCompanyClient {
  Username: string;
  Comment: string;
}

type DispatchProps_t = ReturnType<typeof mapDispatchToProps>;

function NewOpcUaClient({ companyId, clients, onChange, AddMsg }: INewOpcUaClientProps & DispatchProps_t) {
  const emptyNewCompanyClient: INewCompanyClient = { Username: '', Comment: '' };
  const [addClientData, setaddClientData] = useState<INewCompanyClient>(emptyNewCompanyClient);

  //Save new created companydata
  const SaveClientData = async (companyID: string) => {
    Api.OpcUaClient.addClient(companyID, addClientData)
      .then((data) => {
        onChange();
        const response = JSON.parse(JSON.stringify(data.data));
        let confirmation_request =
          'Please safe the new password of the client ' + response.MqttUsername + ' Password: ' + response.Password;
        if (window.confirm(confirmation_request) == true) {
          confirmation_request = 'Safed';
        }
        AddMsg('Created new Client in DB.', 'success ');
        setaddClientData(emptyNewCompanyClient);
      })
      .catch(() => {
        AddMsg('Network response was not ok', 'danger');
      });
  };

  // Check and add Client
  const handleNewClientData = (event: React.ChangeEvent<HTMLInputElement>) => {
    const _addCompanyClient = { ...addClientData } as any;
    _addCompanyClient[event.target.name] = event.target.value;
    setaddClientData(_addCompanyClient);
  };
  const nameAlreadyExist = clients.find((c) => c.MqttUsername === addClientData.Username) !== undefined;

  const onSubmitForm = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (companyId) {
      SaveClientData(companyId);
    }
    return false;
  };

  return (
    <form onSubmit={onSubmitForm}>
      <div className="row">
        <div className="form-group col-md-4 align-self-end">
          <label>Clientname</label>
          <input
            className="form-control"
            name="Username"
            placeholder="Please enter a clientname"
            value={addClientData.Username}
            onChange={(e) => handleNewClientData(e)}
            type="text"
          />
        </div>
        <div className="form-group col-md-4 align-self-end">
          <label>Comment</label>
          <input
            className="form-control"
            name="Comment"
            placeholder="Please enter a comment"
            value={addClientData.Comment}
            onChange={(e) => handleNewClientData(e)}
            type="text"
          />
        </div>
        <div className="form-group col-md-2 align-self-end">
          <label> </label>
          <input
            type="submit"
            className={!nameAlreadyExist ? 'btn btn-primary' : 'btn btn-danger'}
            disabled={nameAlreadyExist || addClientData.Username === '' || addClientData.Comment === ''}
            value={!nameAlreadyExist ? 'Create new client' : 'Client already exist'}
          />
        </div>
      </div>
    </form>
  );
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    AddMsg: (msg: string, severity: BootstrapColor_t) => MsgListActions.Add(msg, severity)(dispatch),
  };
};

export default connect(undefined, mapDispatchToProps)(NewOpcUaClient);
